export default "__VITE_ASSET__BWuCRJWz__"